import { Record, List } from 'immutable';

export const DEFAULT_CUSTOM_CATEGORY_NAME = 'Uncategorized';
export const DEFAULT_CUSTOM_CATEGORY_ID = 19;

const defaultValues = {
  id: null,
  categoryName: '',
  description: '',
  syscoCategoryId: null,
  brandId: null,
  ordinal: 0,
};

export default class RecipeCustomCategory extends Record(defaultValues, RecipeCustomCategory) {
  constructor(values) {
    super({
      ...values,
    });
  }

  static getNextOrdinal(categories) {
    const items = this.sortCategoriesByOrdinal(categories);
    const item = items.last();
    if (item) {
      return item.get('ordinal') + 1;
    }
    return 0;
  }

  static sortCategoriesByOrdinal(categories) {
    return categories.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static getCategoryById(categories, id) {
    return categories.find((item) => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static getCategoryIndexById(categories, id) {
    return categories.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static deleteCategoryByIndex(categories, index) {
    return categories.delete(index);
  }

  static insertCategoryByIndex(categories, index, category) {
    return categories.insert(index, category);
  }

  static formatCategoriesForOrdinalUpdate(categories) {
    const categoryData = {
      ids: [],
    };
    categories.forEach((item) => {
      categoryData.ids.push(item.get('id'));
    });
    return categoryData;
  }

  static updateCategoryOrdinalsFromIndex(categories) {
    return categories.map((item, index) => {
      return item.set('ordinal', index);
    });
  }
}

export const RecipeCustomCategories = (data) => {
  let recipeCustomCategories = new List();
  if(data) {
    data.forEach((value) => {
      const { category } = value;
      recipeCustomCategories = recipeCustomCategories.push(new RecipeCustomCategory(category || value));
    });
  }
  return recipeCustomCategories;
}
